module.exports = __webpack_public_path__ + "img/products_big_can_dragonfruit.85b54469.png";